import PenaltyShootoutSettings from "./PenaltyShootoutSettings";
export default PenaltyShootoutSettings;
